<template>
  <v-col >
    <v-card class="align-start metrics-card-top monthly-performance">
      <v-card-title class="d-flex justify-space-between">
        <div class="hidden-element">Hidden</div>
        <label class="font-weight-bold text-decoration-underline">Whizeo Strategy Report</label>
        <tooltip>
          <p>Average performance, per month, compared with the average performance against the last 3 months</p>
        </tooltip>
      </v-card-title>
      <v-card-text class="d-flex justify-center align-center">
        <div class="d-flex flex-column align-start pr-3">
          <label class="mb-3">Last 30 days</label>
          <strategy-report-table :data="data30days" />
        </div>
        <v-divider class="mb-1" vertical />
        <div class="d-flex flex-column align-start pl-2">
          <label class="mb-3">Past 90 days monthly average</label>
          <strategy-report-table :data="data90days" />
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import Tooltip from "@/components/HealthScore/Tooltip.vue";
import {mapState} from "vuex";
import {LoadingState} from "@/store/constants";
import api from "@/services/support.api";
import StrategyReportTable from "@/components/HealthScore/StrategyReport/StrategyReportTable.vue";

export default {
  name: 'WhizeoStrategyReport',
  components: {StrategyReportTable, Tooltip},
  data() {
    return {
      campaigns: [],
    }
  },
  props: {
    clientId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState('healthScoreStore', ['whizeoHealthScore']),
    loading() {
      return this.whizeoHealthScore.state === LoadingState.LOADING;
    },
    data30days() {
      return this.mapReportToTableData(this.whizeoHealthScore.data.strategyReport30Days);
    },
    data90days() {
      return this.mapReportToTableData(this.whizeoHealthScore.data.strategyReport90Days);
    }
  },
  methods: {
    mapReportToTableData(report) {
      if (!report) {
        return [];
      }
      return report.map((campaignData) => {
        const campaign = this.campaigns.find((campaign) => campaign.clientCampaignId === campaignData.campaignId);
        return {
          campaignName: campaign ? campaign.name : 'Unknown',
          triggeredFromNetTraffic: campaignData.triggeredFromNetTraffic,
          conversionToolEnqFromUniqueNetTraffic: campaignData.conversionToolEnqFromUniqueNetTraffic || 0,
        }
      })
    },
    countPercentage(value, divider) {
      if (divider !== 0) {
        return parseFloat((value / divider * 100).toFixed(2));
      } else {
        return 0;
      }
    }
  },
  async mounted() {
    this.campaigns = await api.getClientCampaigns(this.clientId, true);
  },
  filters: {
    formatNumber(value) {
      return Number(parseFloat(value).toFixed(2));
    }
  },
}
</script>

<style scoped>
.monthly-performance {
  white-space: nowrap;
}
</style>
